import clsx from "clsx"
import React, { FC } from "react"

import { InputProps } from "../../utils/Interfaces"

export const RadioButton: FC<InputProps> = ({
    name,
    value,
    label,
    checked,
    content,
    disabled,
    required,
    changeHandler,
}) => {

    return (
        <>
            <label className="cursor-pointer">
                <input type="radio" className="peer sr-only" disabled={disabled} name={name} value={value} checked={checked} onChange={changeHandler} required={required} />

                <div aria-disabled={disabled} className="max-w-xl rounded-md bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 ring-1 ring-slate-300 dark:ring-slate-500 transition-all hover:shadow peer-checked:text-orange-600 dark:peer-checked:text-orange-300 peer-checked:ring-orange-400 dark:peer-checked:ring-orange-300">
                    <div className="flex flex-col gap-1 px-3 py-1.5">
                        <div className={clsx(content, "flex align-middle gap-x-3")}>
                            <div className="flex-1">
                                {
                                    label
                                }
                            </div>

                            {
                                checked ? (
                                    <div>
                                        <svg className="text-orange-500 dark:text-orange-600 w-4 h-4" width="24" height="24" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="m10.6 13.8l-2.175-2.175q-.275-.275-.675-.275t-.7.3q-.275.275-.275.7q0 .425.275.7L9.9 15.9q.275.275.7.275q.425 0 .7-.275l5.675-5.675q.275-.275.275-.675t-.3-.7q-.275-.275-.7-.275q-.425 0-.7.275ZM12 22q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Z" />
                                        </svg>
                                    </div>
                                ) : (
                                    <div className={`w-4 h-4 rounded-full border border-slate-400 dark:border-slate-400`}></div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </label>
        </>
    )
}